module.exports = __webpack_public_path__ + "img/title-about.850788de.svg";